import { render, staticRenderFns } from "./BaseGrid.vue?vue&type=template&id=176830c2"
import script from "./BaseGrid.vue?vue&type=script&lang=js"
export * from "./BaseGrid.vue?vue&type=script&lang=js"
import style0 from "./BaseGrid.vue?vue&type=style&index=0&id=176830c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports